/**
 * The customer's answer to "Do you have a printer?" on a return, as staff read it.
 *
 * `has_printer` is 1 (yes), 0 (no) or null (a case booked before the question
 * existed). Two screens show it: the Return Items cards and the ticket's case panel.
 *
 * @param {number|boolean|null|undefined} hasPrinter
 * @returns {'Printer'|'No printer'|null} null means "not asked", so show nothing.
 */
export function printerAnswerLabel(hasPrinter) {
    if (hasPrinter == null) return null
    return Number(hasPrinter) === 1 ? 'Printer' : 'No printer'
}
